import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";
import { generateQueryParams } from "../../utils/generateQueryParams";

export const getPaymentDetailsByUnitIdForAdmin = createAsyncThunk(
  "payment/getPaymentDetailsByUnitIdForAdmin",
  async ({ unitId, userId }, { rejectWithValue }) => {
    try {
      const url = userId
        ? `payment/unit-tenant/view-payments-admin/${unitId}?userId=${userId}`
        : `payment/unit-tenant/view-payments-admin/${unitId}`;
      const res = await api.get(url);
      // Backend returns: { success, message, data: { tenantInfoCards, payments } }
      return res.data;
    } catch (err) {
      const msg = err?.response?.data?.message || err.message || "Request failed";
      return rejectWithValue(msg);
    }
  }
);

export const getUnitPaymentDetails = createAsyncThunk(
    "payment/unitPaymentDetails",
    async (unitId, { rejectWithValue }) => {
      try {
        const { data } = await api.get(`payment/unit-tenant/view-payments/${unitId}`);
        return data; // expects { data: { tenantInfoCards: {...}, payments: [...] } }
      } catch (err) {
        const message =
          err?.response?.data?.message || err.message || "Failed to fetch unit payment details";
        return rejectWithValue(message);
      }
    }
  );


export const getTenantPayments = createAsyncThunk(
  "payment/tenantPayments",
  async (params = {}) => {
    const response = await api.get("payment/tenant-payments", { params });
    return response.data;
  }
);

export const getPayoutHistory = createAsyncThunk(
  "payment/payoutHistory",
  async (params = {}) => {
    const response = await api.get("payment/payouts", { params });
    return response.data;
  }
);

export const getPaymentMonitoring = createAsyncThunk(
  "payment/paymentMonitoring",
  async (arg) => {
    const query = generateQueryParams(arg);
    const response = await api.get(`payment/payment-monitoring?${query}`);
    return response.data;
  }
);
 